export type PriceLevel = 'b2c' | 'b2b' | 'vip';

/**
 * Display price from API response (tier already applied in price.selling when backend sent auth).
 */
type Priceable = {
  price?: { selling?: number; mrp?: number } | number;
  price_b2c?: number;
  price_b2b?: number;
  price_vip?: number;
  mrp?: number;
  compare_price?: number;
};

export function getProductSellingPrice(product: Priceable | null | undefined): number {
  if (!product) return 0;
  if (typeof product.price === 'number') return product.price;
  if (product.price?.selling != null && product.price.selling > 0) {
    return product.price.selling;
  }
  if (product.price_b2c && product.price_b2c > 0) return product.price_b2c;
  return 0;
}

export function getProductMrp(product: Priceable | null | undefined): number | null {
  if (!product) return null;
  if (typeof product.price === 'number') {
    return product.mrp ?? product.compare_price ?? null;
  }
  const mrp = product.price?.mrp ?? product.mrp;
  if (mrp != null && mrp > 0) return mrp;
  return null;
}

export function getAppliedPriceLevel(product: {
  appliedPriceLevel?: PriceLevel;
}): PriceLevel | null {
  return product?.appliedPriceLevel || null;
}
